// TODO create interfaces for getting app constants properties
// ie avoid this.$appConstants.tracker.icons.ordering
// preferred:
// const tracker = this.$appConstants.getTracker();
// const icon = tracker.getIconOrdering();
var appDetails = {};
// @ts-ignore
if (window.__app_details) {
    // @ts-ignore
    appDetails = window.__app_details;
}
export default appDetails;



//////////////////
// WEBPACK FOOTER
// ./src/utils/AppConstants.ts
// module id = null
// module chunks = 